import {
  NavigationDrawer as DSNavigationDrawer,
  NavigationDrawerContent,
  NavigationDrawerItem,
  NavigationDrawerTheme,
} from "@globalgiving/components"
import { colors } from "@globalgiving/styles"
import { observer } from "mobx-react-lite"
import { FC } from "react"
import { NavLink, useParams } from "react-router"
import { DashboardIcon } from "~/icons/svg-icons"
import { APP_ROUTES, ENTITY_ROUTES } from "~/router.tsx"
import { entityTaskStore } from "~/stores/domain"

export type NavigationDrawerProps = {
  close?: () => void
}

export const NavigationDrawer: FC<NavigationDrawerProps> = observer(({ close }) => {
  const { id } = useParams()
  const activeTasksURL = `/${APP_ROUTES.Entity}/${id}/${ENTITY_ROUTES.ActiveTasks}`
  const completedTasksURL = `/${APP_ROUTES.Entity}/${id}/${ENTITY_ROUTES.CompletedTasks}`
  const activeTasks = entityTaskStore.activeTasks.flatMap((category) => category.facets)

  return (
    <DSNavigationDrawer close={close} theme={NavigationDrawerTheme.Dark}>
      <NavigationDrawerContent>
        <NavLink className="w-fit" to={activeTasksURL} onClick={close}>
          {({ isActive }) => (
            <NavigationDrawerItem active={isActive} className="inline-flex items-center gap-x-2 p-1">
              <DashboardIcon currentColor={colors.secondary.navy.lightest2} />
              My Active Tasks{!!activeTasks.length && ` (${activeTasks.length})`}
            </NavigationDrawerItem>
          )}
        </NavLink>
        <NavLink className="w-fit" to={completedTasksURL} onClick={close}>
          {({ isActive }) => (
            <NavigationDrawerItem active={isActive} className="inline-flex items-center gap-x-2 p-1">
              <DashboardIcon currentColor={colors.secondary.navy.lightest2} />
              My Completed Tasks
            </NavigationDrawerItem>
          )}
        </NavLink>
      </NavigationDrawerContent>
    </DSNavigationDrawer>
  )
})
